import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    AUTH_PROVIDER_KEY,
    AZURE_SSO_SESSION_KEY,
    MICROSOFT_SESSION_USER_KEY,
    MS_LOGIN_EMAIL_KEY,
    MS_LOGIN_PENDING_KEY,
} from '../../auth/authSessionKeys';
import { isMicrosoftSession, logoutMicrosoft } from '../../auth/microsoftAuth';

export default function Logout() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const microsoftSession = useRef(isMicrosoftSession())
    const started = useRef(false)

    useEffect(() => {
        if (started.current) {
            return
        }
        started.current = true

        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('theme')
        localStorage.removeItem(AUTH_PROVIDER_KEY)
        localStorage.removeItem(MICROSOFT_SESSION_USER_KEY)
        localStorage.removeItem(AZURE_SSO_SESSION_KEY)
        sessionStorage.removeItem(MS_LOGIN_PENDING_KEY)
        sessionStorage.removeItem(MS_LOGIN_EMAIL_KEY)
        dispatch({ type: "logout" })

        if (microsoftSession.current) {
            logoutMicrosoft()
                .then((redirected) => {
                    if (!redirected) {
                        navigate("/login")
                    }
                })
                .catch(() => {
                    navigate("/login")
                })
            return
        }

        navigate("/login")
          // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <></>
    )
}
